import { Suspense } from 'react';

import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';

import type { NsColumnAttributes } from '@connectedhomes/nucleus/types/nucleus';
import type { ScreenParts } from 'components/app/routes/app-routes-revamp';

export const ScreenTemplate = (props: ScreenParts) => {
  const { Content, LeftSidebar, RightSidebar, Header, Skyline, Footer } = props;

  const hasRightSidebar = !!RightSidebar;
  const hasLeftSidebar = !!LeftSidebar;
  let col: NsColumnAttributes['hockey-pitch'];

  switch (true) {
    case hasLeftSidebar && !hasRightSidebar:
      col = '1:2';
      break;
    case !hasLeftSidebar && hasRightSidebar:
      col = '2:1';
      break;
    default:
      col = '1';
  }

  return (
    <>
      {Skyline && (
        <Suspense>
          <Skyline />
        </Suspense>
      )}
      {Header && (
        <NsPanel>
          <Suspense>
            <Header />
          </Suspense>
        </NsPanel>
      )}

      <NsPanel decoration="cyan-light" inset>
        <ns-column key={col} hockey-pitch={col}>
          {hasLeftSidebar && (
            <Suspense>
              <LeftSidebar />
            </Suspense>
          )}
          {Content && (
            <Suspense fallback={<NsStopgap />}>
              <Content />
            </Suspense>
          )}
          {hasRightSidebar && (
            <Suspense>
              <RightSidebar />
            </Suspense>
          )}
        </ns-column>
      </NsPanel>

      {Footer && (
        <Suspense>
          <Footer />
        </Suspense>
      )}
    </>
  );
};
